import path from 'path';

/**
 * Gets the path to the active sessions directory.
 */
export function getActiveSessionsPath(cachePath: string): string {
  return path.join(cachePath, 'active-sessions');
}
